import { Odds } from '@frontend/sports/odds/feature';
import { PlacementErrorType } from '@frontend/sports/types/betslip';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { ResultError } from './result-error';

export class UnderMinimumOdds extends ResultError {
    constructor(
        pickId: string,
        public currentOdds: Odds,
        public expectedOdds: Odds,
        public oddsFormat: OddsDisplayFormat,
    ) {
        super(pickId);
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.UnderMinimumOdds;
    }
}
